// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"80fa8d65","766":"30bd8bc2"}[chunkId] + ".chunk.js";
};